import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useLogoutInFlight } from "@/shared/lib/logoutInFlight";
import { DEV_SKIP_AUTH } from "@/shared/lib/devAuthBypass";

export function ProtectedRoute({ children }: { children: React.ReactNode }) {
  if (DEV_SKIP_AUTH) {
    return <>{children}</>;
  }
  return <KindeProtectedRoute>{children}</KindeProtectedRoute>;
}

function KindeProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useKindeAuth();
  const navigate = useNavigate();
  const loggingOut = useLogoutInFlight();
  const [hasAuthenticated, setHasAuthenticated] = useState(false);

  useEffect(() => {
    if (isAuthenticated) {
      setHasAuthenticated(true);
    }
  }, [isAuthenticated]);

  useEffect(() => {
    if (loggingOut) return;
    if (!isLoading && !isAuthenticated) {
      navigate("/", { replace: true });
    }
  }, [isAuthenticated, isLoading, loggingOut, navigate]);

  if (loggingOut) {
    return (
      <div className="h-screen grid place-content-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-500"></div>
      </div>
    );
  }

  if (hasAuthenticated) {
    if (!isLoading && !isAuthenticated) {
      return null;
    }
    return <>{children}</>;
  }

  if (isLoading) {
    return (
      <div className="h-screen grid place-content-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-purple-500"></div>
      </div>
    );
  }

  return isAuthenticated ? <>{children}</> : null;
}
